var React = require('react');

function OrderDetailCross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 4.5L19.5 19.5M19.5 4.5L4.5 19.5","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

OrderDetailCross.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = OrderDetailCross;

OrderDetailCross.default = OrderDetailCross;
